import { render } from "./twitter.vue?vue&type=template&id=6acb8044"
import script from "./twitter.vue?vue&type=script&lang=js"
export * from "./twitter.vue?vue&type=script&lang=js"

import "./twitter.vue?vue&type=style&index=0&id=6acb8044&lang=css"
script.render = render

export default script